import {
  dynamicImages,
  logos,
  placeholders as placeholderSets,
  standardImages,
  standardRegionImages,
  type TDynamicImageKeys,
  type TPlaceholderKeys,
  type TStandardImageKeys,
  type TStandardRegionImageKeys,
} from '~/assets/data/branding-library';
import { useEnvironment } from '~/composables/useStates/useEnvironment';

export default function useBranding() {
  const environment = useEnvironment();
  const colorMode = useColorMode();
  const lookup = computed(() =>
    environment.value.regionConfigs.isGlobal ? 'global' : 'za',
  );
  const logo = ref<string>();
  const logoSets = logos[lookup.value];
  watchEffect(() => {
    logo.value = logoSets[colorMode.value];
  });

  const placeholders = placeholderSets[lookup.value];

  const getPlaceholder = (key: TPlaceholderKeys) =>
    useImagePath(placeholders[key]);
  const getImage = (key: TStandardImageKeys) => standardImages[key];
  const getRegionImage = (key: TStandardRegionImageKeys) =>
    standardRegionImages[lookup.value][key];
  const getDynamicImage = (
    key: TDynamicImageKeys,
    replaceValue: Record<string, string>,
  ) => {
    let path = String(dynamicImages[key]);
    const replaceValues = Object.entries(replaceValue);

    replaceValues.forEach(([k, v]) => {
      path = path.replace(`{${k}}`, v);
    });
    return path;
  };

  return {
    logo,
    logoSets,
    placeholders,
    getPlaceholder,
    getImage,
    getRegionImage,
    getDynamicImage,
  };
}
